// src/components/admin/template/MoveGroupingForm.tsx

import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { GroupingWithId, PropertyTemplatesWithIds } from './MetadataInterfaces';

interface MoveGroupingFormProps {
  grouping: GroupingWithId;
  currentPropertyType: string;
  propertyTemplates: PropertyTemplatesWithIds;
  onSave: (
    grouping: GroupingWithId,
    destinationPropertyType: string,
    isCopy: boolean,
  ) => void;
  onCancel: () => void;
}

const MoveGroupingForm: React.FC<MoveGroupingFormProps> = ({
  grouping,
  currentPropertyType,
  propertyTemplates,
  onSave,
  onCancel,
}) => {
  const [selectedPropertyType, setSelectedPropertyType] =
    useState(currentPropertyType);
  const [isCopy, setIsCopy] = useState(false);

  const propertyTypes = Object.keys(propertyTemplates);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedPropertyType === currentPropertyType && !isCopy) {
      alert('The destination property type is the same as the current one.');
      return;
    }
    onSave(grouping, selectedPropertyType, isCopy);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <FormControl fullWidth margin="normal">
        <InputLabel>Property Type</InputLabel>
        <Select
          value={selectedPropertyType}
          onChange={(e) => setSelectedPropertyType(e.target.value)}
        >
          {propertyTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={isCopy}
            onChange={(e) => setIsCopy(e.target.checked)}
          />
        }
        label="Copy grouping instead of moving"
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {isCopy ? 'Copy Grouping' : 'Move Grouping'}
        </Button>
      </Box>
    </Box>
  );
};

export default MoveGroupingForm;
